import editIcon from '../../../../assets/images/edit-icon.svg';
import removeIcon from '../../../../assets/images/delete-button.svg';
import activeIcon from '../../../../assets/images/active-icon.svg';
import suspendedIcon from '../../../../assets/images/suspended-icon.svg';
import styles from './index.module.scss';
import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal';

interface ActionsModalProps {
    item: any;
    hasDelete: boolean;
    navigateToItemPage: (item: any) => void;
    deleteItem: (itemId: string) => void;
    updateStatus: (itemId: string, status: string) => void;
}

const ActionsModal = ({ item, navigateToItemPage, deleteItem, updateStatus, hasDelete = true }: ActionsModalProps) => {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const { status, _id } = item;
    const isActive = status.toLowerCase() === 'active';

    const closeModal = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowDeleteConfirm(false);
    };

    const showConfirmDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowDeleteConfirm(true);
    };

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        deleteItem(_id);
        closeModal(e);
    };

    const handleUpdateStatus = (e: React.MouseEvent) => {
        e.stopPropagation();
        updateStatus(_id, isActive ? 'Suspend' : 'Active');
        closeModal(e);
    };

    const actions = [
        {
            icon: editIcon,
            altText: 'Edit icon',
            label: 'Edit',
            onClick: () => navigateToItemPage(item)
        },
        {
            icon: isActive ? activeIcon : suspendedIcon,
            altText: isActive ? 'Suspend icon' : 'Activate icon',
            label: isActive ? 'Suspend' : 'Activate',
            onClick: handleUpdateStatus
        },
        ...(hasDelete ? [
            {
                icon: removeIcon,
                altText: 'Remove icon',
                label: 'Remove',
                onClick: showConfirmDelete
            }
        ] : [])
    ];

    return (
        <>
            <div className={styles.modal}>
                {actions.map((action, index) => (
                    <div key={index} className={styles.action} onClick={action.onClick}>
                        <img src={action.icon} alt={action.altText} />
                        <div>{action.label}</div>
                    </div>
                ))}
            </div>
            {showDeleteConfirm && (<ConfirmModal
                onCancel={closeModal}
                onConfirm={handleDelete}
            />)}
        </>
    );
};

export default ActionsModal;
